import React from 'react'

const Backend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Backend Development</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data" data-aos="zoom-in" data-aos-delay="100">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Node Js</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data" data-aos="zoom-in" data-aos-delay="200">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">Java</h3>
                        <span className="skills__level">Basic</span>
                    </div>
                </div>

                <div className="skills__data" data-aos="zoom-in" data-aos-delay="300">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">React</h3>
                        <span className="skills__level">Basic</span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data" data-aos="zoom-in" data-aos-delay="400">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">MongoDB</h3>
                        <span className="skills__level">Intermediate</span>
                    </div>
                </div>

                <div className="skills__data" data-aos="zoom-in" data-aos-delay="500">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">MySQL</h3>
                        <span className="skills__level">Basic</span>
                    </div>
                </div>

                <div className="skills__data" data-aos="zoom-in" data-aos-delay="600">
                    <i className='bx bx-badge-check' ></i>

                    <div>
                        <h3 className="skills__name">PostgreSQL</h3>
                        <span className="skills__level">Basic</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Backend